import React, { useContext, useEffect } from 'react';
import Layout from '../../../components/Layout/user/Layout';
import classes from './styles.module.scss';
import { GlobalContext } from '../../../context/provider';
import { getWishList } from '../../../context/actions/products';
import ProductBlock from '../../../components/cards/Product_Block';
import { Link } from 'react-router-dom';

const WishList = () => {
  const { productState, productDispatch } = useContext<any>(GlobalContext);

  useEffect(() => {
    getWishList()(productDispatch);
  }, []);

  const wishlistProducts = productState.wishlist;

  return (
    <Layout enableScrollToToP={true}>
      <div className="w-full px-4 md:px-8 py-4">
        <h1 className="text-lg w-full text-center pb-8 font-semibold">Favorites</h1>
        {!wishlistProducts?.length && (
          <div className='w-full text-center'>
            <p className="w-full text-center text-base text-primary">
              You don't have any favorites yet!
            </p>
            <Link to="/stores"><span className="text-bold underline cursor-pointer">Start here</span></Link>
          </div>
        )}
        <div className={'w-full grid grid-cols-2 md:grid-cols-6 gap-2'}>
          {wishlistProducts?.map((item: any, index: number) => {
            return <ProductBlock data={item.product} key={index} />;
          })}
        </div>
      </div>
    </Layout>
  )
};

export default WishList;
